import { __assign, __rest } from "tslib";
import React from 'react';
import { Trans } from 'react-i18next';
import { Url } from '@wix/da-url';
import UserLink from '../../../User/Link/UserLink';
import BiLink from '../../../biLogger/Components/BiLink';
import { BiEventType, ReferralType } from '../../../biLogger/constants';
import HiddenLayout from './HiddenLayout';
import Hidden from './Icons/Hidden';
import hiddenStyles from './Hidden.scss';
var AntisocialBlockedFullView = function (_a) {
    var author = _a.deviation.author, deviation = _a.deviation, props = __rest(_a, ["deviation", "deviation"]);
    return (React.createElement(HiddenLayout, __assign({ icon: React.createElement(Hidden, null), text: [
            /* prettier-ignore */
            author && React.createElement(Trans, { key: "antisocial", i18nKey: "deviationview.blocked.antisocial" },
                React.createElement(UserLink, { user: author, className: hiddenStyles['link'] }),
                " has limited the viewing of this artwork to members of the DeviantArt community only."),
            /* prettier-ignore */
            React.createElement(Trans, { key: "antisocial-cta", i18nKey: "deviationview.blocked.antisocial.loginOrJoin" },
                "You can",
                ' ',
                React.createElement("a", { href: Url.loginLink(), className: hiddenStyles['link'] }, "log in"),
                ' ',
                "or",
                ' ',
                React.createElement(BiLink, { href: Url.joinLink(), className: hiddenStyles['link'], biData: {
                        evid: BiEventType.REDIRECT_TO_LOGIN,
                        referral_info: ReferralType.ANTISOCIAL,
                    } }, "become a member"),
                ' ',
                "for FREE."),
        ], deviation: deviation }, props)));
};
AntisocialBlockedFullView.displayName = 'AntisocialBlockedFullView';
export default AntisocialBlockedFullView;
//# sourceMappingURL=AntisocialBlocked.js.map